import React from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {DealActivityNoteItem} from 'yougile-model'
import {useUserProxy} from '@components/common/base/avatar/use-user-proxy'
import {Icon} from '@components/common/base/icon'
import {TwMessageContainer, TwMessageIcon} from './common'
import {DealActivityDeleteButton} from './deal-activity-delete-button'
import {DealTimeLineMessageProps} from './types'

export const DealTimeLineNoteMessage = (
  props: DealTimeLineMessageProps<DealActivityNoteItem>
) => {
  const {activity, deal} = props
  const user = useUserProxy(activity.from)

  return (
    <TwMessageContainer key={activity.id}>
      <TwMessageIcon $bgOrange>
        <Icon icon="IconCustomDealComment" />
      </TwMessageIcon>
      <div className="bg-sticker-orange text-14 p-12 rounded-12 shadow-xs group w-full">
        <div className="flex justify-between gap-6">
          <div style={{wordBreak: 'break-word'}}>{activity.text}</div>
        </div>
        <div className="flex text-12 text-secondary mt-4 max-h-16">
          <div className="flex gap-12">
            {Time.formatDateTime(activity.timestamp)}{' '}
            <span className="ml-8">{user?.userName}</span>
          </div>

          <DealActivityDeleteButton
            deal={deal}
            activity={activity}
            tooltip={Lang.msg.crm.rightPanel.dealHistory.deleteNoteActivity}
            confirmationTitle={
              Lang.msg.crm.rightPanel.dealHistory.deleteNoteActivity
            }
            confirmationDescription={
              Lang.msg.crm.rightPanel.dealHistory.deleteNoteActivityConfirmation
            }
          />
        </div>
      </div>
    </TwMessageContainer>
  )
}
